import TransformComponent from "grimoirejs-fundamental/ref/Components/TransformComponent";
import Component from "grimoirejs/ref/Node/Component";
export default class GLTFAnimationComponent extends Component {
    $mount() {
        this._startTime = (new Date()).getTime();
        this._animation = this.getAttribute("animation");
    }
    $update() {
        if (!this._targetTransforms) {
            this._targetTransforms = {};
            const targets = this._animation.targetNodes;
            for (let target of targets) {
                const nodes = this.node.parent.parent.parent.getChildrenByClass(target);
                if (nodes.length > 0) {
                    this._targetTransforms[target] = nodes[0].getComponent(TransformComponent);
                }
            }
        }
        const t = ((new Date()).getTime() - this._startTime) / 1000;
        this._animation.processCurrentFrame(t % this._animation.timeLength, (id, path, v) => {
            const transform = this._targetTransforms[id];
            if (!transform) {
                return;
            }
            switch (path) {
                case "translation":
                    transform.position.rawElements = v;
                    break;
                case "rotation":
                    transform.rotation.rawElements = v;
                    break;
                case "scale":
                    transform.scale.rawElements = v;
                    break;
            }
        });
        for (let tr in this._targetTransforms) {
            this._targetTransforms[tr].notifyUpdateTransform();
        }
    }
    $unmount() {
    }
}
GLTFAnimationComponent.attributes = {
    play: {
        converter: "Boolean",
        default: false
    },
    animation: {
        converter: "Object",
        default: null
    },
    frame: {
        converter: "Number",
        default: 0
    }
};



// WEBPACK FOOTER //
// ./src/Components/GLTFAnimationComponent.ts